import { AnyOperationLogEntityVersion } from '@uploadcam/common';
import { CollectionReference, deleteDoc, doc } from 'firebase/firestore';
import { OperationLog } from '../models/operation-log';

export class DeleteOperationLogInteractor {
  constructor(private readonly collection: CollectionReference<AnyOperationLogEntityVersion>) {}

  public async execute(log: OperationLog<any>): Promise<void> {
    await deleteDoc(doc(this.collection, log.id));
  }
}
